export default __webpack_public_path__ + "static/media/improvement-chart.d4fad912.svg";